export const testId = {
    additionalMenu: "additional-menu",
    currentStatus: "current-status",
    customMenu: "custom-menu",
    newsItem: "news-item",
    newsline: "newsline",
    operatorStatusTimer: "operator-status-timer",
    projectSelector: "project-selector",
    searchProject: "search-project",
    projectCard: "project-card"
} as const
